"use strict";

import Mustache from '../../node_modules/mustache';
import { PowerGlitch } from '../../node_modules/powerglitch';
import questions from 'bundle-text:./data/questions.json';
import results from 'bundle-text:./data/results.json';
export const QUESTIONS = JSON.parse(questions);
export const RESULTS = JSON.parse(results);
import soundButtonUrl from '../assets/sounds/click_003.ogg';
import soundResultUrl from '../assets/sounds/scratch_003.ogg';

let questionTemplate;
let currentQuestion = 0;
let scores = { A: 0, B: 0, C: 0, D: 0, E: 0, F: 0 };
const delay = ms => new Promise(res => setTimeout(res, ms));

function updateProgress(current, total) {
  let progressBar = document.getElementById("progress");
  let progressValue = document.getElementById("progressvalue");

  progressBar.dataset.label = "Question " + (current + 1) + " of " + total;
  progressValue.style.width = current / total * 100 + "%";
};

function showQuestion() {
  let question = QUESTIONS[currentQuestion];
  let questionText = document.getElementById("question");
  let answers = document.getElementById("answers");

  // Show question   
  updateProgress(currentQuestion, QUESTIONS.length);
  PowerGlitch.glitch(questionText,
    {
      "html": question.text,
      "timing": {
        "duration": 250,
        "iterations": 1
      },
      "glitchTimeSpan": {
        "start": 0,
        "end": 1
      },
      "slice": {
        "count": 15,
        "velocity": 20
      }
    }
  );

  // Shuffle answers
  question.answers = question.answers
    .map(value => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value)

  // Show answers
  answers.innerHTML = Mustache.render(questionTemplate, { answers: question.answers });

  let currentAnswer = 0;

  Array.from(answers.getElementsByTagName("button")).forEach(button => {

    let answerNumber = currentAnswer;

    button.onclick = () => {

      QUESTIONS[currentQuestion].answers[answerNumber].scores.forEach(score => scores[score] += 1);
      currentQuestion++;

      if (currentQuestion >= QUESTIONS.length) {

        const audio = new Audio(soundResultUrl);
        audio.currentTime = 0;
        audio.play();

        showResult();
      } else {

        const audio = new Audio(soundButtonUrl);
        audio.currentTime = 0;
        audio.play();

        showQuestion();
      }
    }

    currentAnswer++;
  });

}
function showResult() {
  let questionText = document.getElementById("question");
  let answers = document.getElementById("answers");
  let progressBar = document.getElementById("progress");

  progressBar.style.display = "none";

  // Animate loading
  answers.style.display = "none";
  PowerGlitch.glitch(questionText,
    {
      "html": "Analyzing...",
      "timing": {
        "duration": 500,
        "iterations": 1
      },
      "glitchTimeSpan": {
        "start": 0,
        "end": 1
      },
      "slice": {
        "count": 15,
        "velocity": 20
      }
    }
  );

  const showResult = async () => {
    await delay(1000);

    questionText.innerHTML = "The results are in!";
    answers.style.display = "block";

    let bestResult = null;
    let bestScore = 0;

    RESULTS.forEach(result => {
      let currentScore = result.scores.reduce((accumulator, currentValue) => accumulator + scores[currentValue], 0);

      if (currentScore >= bestScore) {
        bestScore = currentScore;
        bestResult = result;
      }
    });

    console.log(scores);
    console.log(bestResult);

    // Show answers
    let resultTemplate = document.getElementById("resultTemplate").innerHTML;
    answers.innerHTML = Mustache.render(resultTemplate, bestResult);

    window.addEventListener(
      'blur',
      () => {
        setTimeout(() => {
          if (document.activeElement.tagName === 'IFRAME') {
            umami.track('Spotify'); // eslint-disable-line no-undef
          }
        });
      },
      { once: true }
    );

  };

  showResult();
}

document.addEventListener("DOMContentLoaded", function () {
  questionTemplate = document.getElementById("questionTemplate").innerHTML;

  document.getElementById("envelope").addEventListener("click", function () {
    showQuestion();
    document.getElementById("progress").style.visibility = "visible";
  });
});